<div class="flex flex-col gap-4 mt-1">
  <div>
    <p-floatlabel variant="on">
      <generic-dropdown
        class="w-full"
        [items]="locationOptions.value()"
        [clearable]="true"
        [formControl]="locationIdsControl"
        [multiselect]="true"
        placeholder=""
      />
      <label>Location</label>
    </p-floatlabel>
    @if ( (locationOptions.status() === 'idle' || locationOptions.status() === 'resolved') &&
    !locationOptions.value().length ) {
    <p-message class="mt-1.5" severity="error" size="small">No locations available for this product.</p-message>
    }
  </div>
  @if (locationCount() > 1) {
  <p-tabs
    scrollable
    [value]="activeLocationId() ?? undefined"
    (valueChange)="activeLocationId.set($any($event))"
    [pt]="{ root: { class: 'flex flex-col' } }"
  >
    <p-tablist class="shrink-0">
      @for (loc of selectedLocationList(); track loc.locationId) {
      <p-tab [value]="loc.locationId || undefined">{{ loc.locationName }}</p-tab>
      }
    </p-tablist>

    <p-tabpanels class="p-0 pt-4 !bg-transparent" [pt]="{ root: { class: 'p-0 pt-4 !bg-transparent' } }">
      @for (loc of selectedLocationList(); track loc.locationId) {
      <p-tabpanel [value]="loc.locationId || undefined">
        <ng-container *ngTemplateOutlet="formTemplate; context: { $implicit: loc }"></ng-container>
      </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
  } @else {
  <ng-container *ngTemplateOutlet="formTemplate; context: { $implicit: selectedLocationList()[0] }"></ng-container>
  }

  <ng-template #formTemplate let-loc>
    <div [formGroup]="loc.group" class="flex flex-col gap-4">
      <!-- Quantity -->
      <div>
        @if (noMeasurementPerLocation()[loc.locationId || '']) {
        <p-message class="mb-1.5" severity="warn" size="small">
          No measurement defined for this room. Enter quantity manually.
        </p-message>
        }
        <p-floatlabel variant="on">
          <p-inputNumber class="w-full" formControlName="quantity" [min]="1" [showButtons]="false" />
          <label class="block text-body-sm-500 text-surface-700 mb-1.5">
            Quantity <span class="text-red-500 ml-0.5">*</span>
          </label>
        </p-floatlabel>
        @if ((submitAttempted() || loc.group.controls.quantity.touched) && loc.group.controls.quantity.invalid) {
        <p class="text-red-500 ml-0.5">Quantity is required.</p>
        }
      </div>

      <!-- Unit Price -->
      <p-floatlabel variant="on">
        <currency-input-field
          class="w-full"
          formControlName="unitPrice"
          [min]="null"
          placeholder=""
          [errormessage]="'Unit Price is required.'"
          [customClass]="'form-control'"
          [uomSuffix]="product().uom"
        />
        <label class="z-10"> Unit Price </label>
      </p-floatlabel>
      <!-- Attributes -->
      @if (productAttributes().length) {
      <div [formGroup]="getAttributeValuesGroup(loc.group)" class="flex flex-col gap-4">
        @for (attribute of productAttributes(); track attribute.subCategoryAttributeId) {
        <div>
          <label class="block text-body-sm-500 text-surface-700 mb-1.5">
            {{ attribute.subCategoryAttributeName }} @if (product().selectionRequired) {
            <span class="text-red-500 ml-0.5">*</span>
            }
          </label>
          <generic-dropdown
            class="w-full"
            [placeholder]="'Select ' + attribute.subCategoryAttributeName"
            [items]="attributeValueOptions().get(attribute.subCategoryAttributeId) ?? []"
            [clearable]="true"
            [allowSearch]="true"
            [formControlName]="attribute.subCategoryAttributeId"
          />
          @if (!attributeValueOptions().get(attribute.subCategoryAttributeId)?.length) {
          <p class="text-body-xs text-surface-400 m-0 mt-1">No values available for this attribute.</p>
          } @if ( (submitAttempted() ||
          getAttributeValuesGroup(loc.group).get(attribute.subCategoryAttributeId)?.touched) &&
          getAttributeValuesGroup(loc.group).get(attribute.subCategoryAttributeId)?.invalid ) {
          <p-message class="mt-1.5" severity="error" variant="outlined" size="small">
            {{ attribute.subCategoryAttributeName }} is required.
          </p-message>
          }
        </div>
        }
      </div>
      } @else {
      <div>
        <label class="block text-body-sm-500 text-surface-700 mb-1.5">Attributes</label>
        @if (hasAttributeConfigError()) {
        <p-message class="mt-1.5" severity="error" size="small">
          Attribute selection is required but attributes are missing. This option cannot be configured.
        </p-message>
        } @else {
        <p class="text-body-sm text-surface-500 font-light text-sm m-0 italic">
          No attributes available for this product.
        </p>
        }
      </div>
      }
      <div>
        <label class="block text-body-sm-500 text-surface-700 mb-1.5">Sales Description</label>
        <p class="text-body-sm text-surface-700 m-0">{{ product().salesDescription || '—' }}</p>
      </div>
      <div>
        <label class="block text-body-sm-500 text-surface-700 mb-1.5">Option Notes</label>
        <textarea pTextarea rows="4" class="w-full" placeholder="Add Notes" formControlName="notes"></textarea>
      </div>
      @if (locationCount() > 1) {
      <div class="flex justify-start mb-4">
        <p-button
          label="Apply current to all locations"
          size="small"
          icon="pi pi-arrow-right-arrow-left"
          severity="primary"
          [outlined]="true"
          (onClick)="applyCurrentToAllLocations()"
        />
      </div>
      }
    </div>
  </ng-template>
</div>
